import styled from 'styled-components';

import {colors, transition} from 'theme';

export const LegendContainer = styled.div`
    display: flex;
    flex-flow: column wrap;
`;

export const LegendItem = styled.div<{isActive: boolean}>`
    display: flex;
    flex-flow: column wrap;
    margin-bottom: 20px;
    transition: all ${transition.duration};

    opacity: ${(p) => (p.isActive ? '1' : '0.2')};
`;

export const LegendItemHeader = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
`;

export const PercentLabel = styled.span`
    color: ${colors.textPrimary};
`;

export const BarContainer = styled.div<{height: number}>`
    position: relative;
    border: 1px solid ${colors.border};
    border-radius: ${(p) => p.height * 2}px;
    height: ${(p) => p.height}px;
    width: 100%;
    background: #f4f4f4;
    overflow: hidden;
`;

export const Bar = styled.div<{width: number; color: string}>`
    position: absolute;
    width: ${(p) => (p.width ? `calc(${p.width}% + 2px)` : 0)};
    left: -1px;
    top: -1px;
    height: calc(100% + 2px);
    border-radius: 36px;
    background-color: ${(p) => p.color};
`;
